import { render, staticRenderFns } from "./abroad-employee.vue?vue&type=template&id=79b7f0f6&scoped=true&"
import script from "./abroad-employee.vue?vue&type=script&lang=js&"
export * from "./abroad-employee.vue?vue&type=script&lang=js&"
import style0 from "./abroad-employee.vue?vue&type=style&index=0&id=79b7f0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7f0f6",
  null
  
)

export default component.exports